export default "__VITE_ASSET__BFB7c77o__"